import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Box,
    Button
} from '@mui/material';
//import AppleIcon from '@mui/icons-material/Apple';
import GoogleIcon from '@mui/icons-material/Google';
//import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';


const MapAppChooser = ({showMapChooser, handleCloseMapChooser, googleMapsLink, copilotLink, setShowMapChooser}) => {
    
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleNav = () => {
        //window.open(link, '_blank');
        setShowMapChooser(false);
    }

    return <>
        <Dialog
            fullScreen={fullScreen}
            open={showMapChooser}
            onClose={handleCloseMapChooser}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">
                {"Choose your navigation app."}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Box  display="flex" flexDirection="column" justifyContent="center" gap={3}  alignItems="center"  minHeight="100vh">
                        {/* <Button onClick={() => {handleNav(appleMapsLink)}} startIcon={<AppleIcon />} sx={{minWidth: '200px'}} variant="contained">Open Apple Maps</Button>
                        <Button onClick={() => {handleNav(wazeLink)}} startIcon={<DirectionsCarIcon />} sx={{minWidth: '200px'}} variant="contained">Open Waze</Button> */}
                        <a href={googleMapsLink} onClick={handleNav} target='_blank'><Button startIcon={<GoogleIcon />} sx={{minWidth: '200px'}} variant="contained">Open Google Maps</Button></a>
                        <a href={copilotLink} onClick={handleNav} target='_blank'><Button startIcon={<DoubleArrowIcon />} sx={{minWidth: '200px'}} variant="contained">CoPilot</Button></a>
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={() => {setShowMapChooser(false)}} sx={{minWidth: '200px'}} variant='contained'>Cancel</Button>
            </DialogActions>
        </Dialog>
    </>
}

export default MapAppChooser;